import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';
import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

interface PostClarificationFilesPayload {
  id: string;
  body: any;
  productId: string;
  replyId?: string;
}

const postClarificationFile = async (
  payload: PostClarificationFilesPayload
): Promise<any> => {
  try {
    const { id, body } = payload;
    const url = payload.replyId
      ? `/clarifications/${id}/replies/${payload.replyId}/files/`
      : `/clarifications/${id}/files/`;

    const { data } = await apiService.post<any>(url, body, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export const useClarificationFiles = () => {
  const queryClient = useQueryClient();
  const id = useAuthStore((state) => state.user?.id);

  return useMutation({
    mutationFn: async (payload: PostClarificationFilesPayload) => {
      return await postClarificationFile(payload);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['product-updates', id, variables.productId]
        }),
        queryClient.invalidateQueries({
          queryKey: ['product', variables.productId]
        })
      ]);
    }
  });
};
